import React from "react";
import { Badge } from "./ui/badge";

const STYLES = {
  Ongoing: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  Completed: "bg-indigo-500/15 text-indigo-400 border-indigo-500/30",
  Hiatus: "bg-amber-500/15 text-amber-400 border-amber-500/30",
};

export const StatusBadge = ({ status }) => (
  <Badge
    data-testid={`status-badge-${(status || "").toLowerCase()}`}
    className={`font-mono-kh text-[10px] uppercase tracking-widest border px-2.5 py-0.5 rounded-full ${STYLES[status] || STYLES.Ongoing}`}
  >
    {status}
  </Badge>
);
